export default __webpack_public_path__ + "static/media/phases_form_to_frame.d6b84022.webp";